/*Copyright (c) 2026. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc.
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

export const normalizeOrganizationGroupId = (value: string) => {
  return value
    .toLowerCase()
    .replace(/\s+/g, ".")
    .replace(/[^a-z0-9.]/g, "")
    .replace(/\.+/g, ".")
    .replace(/^\.+|\.+$/g, "");
};
